/* ============================================
   WW1991 — Currency Converter JS (optimised)
   ============================================ */

(function() {
  'use strict';

  var CURRENCIES = [
    { code: 'USD', symbol: '$',   name: 'US Dollar',      flag: '🇺🇸' },
    { code: 'ILS', symbol: '₪',   name: 'Israeli Shekel',  flag: '🇮🇱' },
    { code: 'EUR', symbol: '€',   name: 'Euro',            flag: '🇪🇺' },
    { code: 'GBP', symbol: '£',   name: 'British Pound',  flag: '🇬🇧' },
    { code: 'RON', symbol: 'lei', name: 'Romanian Leu',   flag: '🇷🇴' },
    { code: 'GHS', symbol: '₵',  name: 'Ghanaian Cedi',  flag: '🇬🇭' }
  ];

  var STORAGE_KEY     = 'ww_currency';
  var RATES_CACHE_KEY = 'ww_currency_rates';
  var RATES_TS_KEY    = 'ww_currency_ts';
  var CACHE_TTL       = 3600000;

  var rates           = {};
  var currentCurrency = localStorage.getItem(STORAGE_KEY) || 'USD';
  var debounceTimer   = null;
  var cartObserver    = null;
  var observing       = false;

  function debounce(fn, ms) {
    return function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fn, ms);
    };
  }

  function fetchRates() {
    var cached = localStorage.getItem(RATES_CACHE_KEY);
    var ts     = parseInt(localStorage.getItem(RATES_TS_KEY) || '0');
    if (cached && Date.now() - ts < CACHE_TTL) {
      try {
        rates = JSON.parse(cached);
        updateAllPrices();
        updateRateDisplay();
        return;
      } catch(e) {}
    }
    fetch('https://open.er-api.com/v6/latest/ILS')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.rates) {
          rates = data.rates;
          try {
            localStorage.setItem(RATES_CACHE_KEY, JSON.stringify(rates));
            localStorage.setItem(RATES_TS_KEY, String(Date.now()));
          } catch(e) {}
          updateAllPrices();
          updateRateDisplay();
        }
      })
      .catch(function() {
        rates = { USD: 0.27, ILS: 1, EUR: 0.25, GBP: 0.21, RON: 1.24, GHS: 3.3 };
        updateAllPrices();
      });
  }

  function formatAmount(amount, code) {
    if (code === 'RON') return amount.toFixed(2) + ' lei';
    var cur = CURRENCIES.find(function(c) { return c.code === code; });
    return (cur ? cur.symbol : code) + amount.toFixed(2);
  }

  function updateAllPrices() {
    if (currentCurrency === 'ILS' || !rates[currentCurrency]) {
      document.querySelectorAll('.price-converted').forEach(function(el) { el.remove(); });
      return;
    }
    var rate = rates[currentCurrency];
    document.querySelectorAll('[data-price-ils]').forEach(function(el) {
      var ils = parseFloat(el.dataset.priceIls);
      if (isNaN(ils)) return;
      var formatted = formatAmount(ils * rate, currentCurrency);
      var next = el.nextElementSibling;
      if (next && next.classList.contains('price-converted')) {
        next.textContent = formatted;
      } else {
        var span = document.createElement('span');
        span.className = 'price-converted';
        span.textContent = formatted;
        el.parentNode.insertBefore(span, el.nextSibling);
      }
    });
  }

  function updateRateDisplay() {
    document.querySelectorAll('.currency-picker__option').forEach(function(opt) {
      var code   = opt.dataset.code;
      var rateEl = opt.querySelector('.currency-picker__option-rate');
      if (rateEl && rates[code]) rateEl.textContent = '1 ₪ = ' + formatAmount(rates[code], code);
      opt.classList.toggle('active', code === currentCurrency);
    });
  }

  function tagPrices() {
    var priceEl = document.getElementById('product-price');
    if (priceEl && !priceEl._wwObserved) {
      priceEl._wwObserved = true;
      var tagAndConvert = debounce(function() {
        var v = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ''));
        if (!isNaN(v)) { priceEl.dataset.priceIls = v; updateAllPrices(); }
      }, 120);
      new MutationObserver(tagAndConvert).observe(priceEl, { childList: true, characterData: true, subtree: true });
      var v0 = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ''));
      if (!isNaN(v0)) priceEl.dataset.priceIls = v0;
    }
    document.querySelectorAll('.product-card__price, .cart-item__price, .cart-subtotal__val').forEach(function(el) {
      if (el.dataset.priceIls) return;
      var v = parseFloat(el.textContent.replace(/[^\d.]/g, ''));
      if (!isNaN(v)) el.dataset.priceIls = v;
    });
  }

  var debouncedRefresh = debounce(function() {
    pauseCartObserver();
    tagPrices();
    updateAllPrices();
    resumeCartObserver();
  }, 200);

  function pauseCartObserver() {
    if (cartObserver && observing) { cartObserver.disconnect(); observing = false; }
  }
  function resumeCartObserver() {
    var cartItems = document.querySelector('.cart-drawer__items');
    if (cartObserver && cartItems && !observing) {
      cartObserver.observe(cartItems, { childList: true });
      observing = true;
    }
  }

  function buildPicker() {
    if (document.getElementById('ww-currency-picker')) return;
    var wrap = document.createElement('div');
    wrap.className = 'currency-picker';
    wrap.id = 'ww-currency-picker';
    var cur = CURRENCIES.find(function(c) { return c.code === currentCurrency; }) || CURRENCIES[0];
    wrap.innerHTML =
      '<button class="currency-picker__btn" id="currency-picker-btn" aria-haspopup="listbox" aria-expanded="false">'
        + '<span id="currency-picker-label">' + cur.flag + ' ' + cur.code + '</span>'
        + '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="10" height="10"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg>'
      + '</button>'
      + '<div class="currency-picker__dropdown" role="listbox" id="currency-picker-dropdown">'
        + CURRENCIES.map(function(c) {
            return '<button class="currency-picker__option' + (c.code === currentCurrency ? ' active' : '') + '" data-code="' + c.code + '" role="option" aria-selected="' + (c.code === currentCurrency) + '">'
              + '<span>' + c.flag + ' ' + c.code + '</span>'
              + '<span class="currency-picker__option-rate"></span>'
            + '</button>';
          }).join('')
      + '</div>';

    /* Inject AFTER the cart icon wrap — last child of site-nav__right */
    var navRight = document.querySelector('.site-nav__right');
    if (navRight) {
      navRight.appendChild(wrap);
    }

    var btn      = document.getElementById('currency-picker-btn');
    var dropdown = document.getElementById('currency-picker-dropdown');

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      wrap.classList.toggle('currency-picker--open');
      btn.setAttribute('aria-expanded', wrap.classList.contains('currency-picker--open'));
    });
    document.addEventListener('click', function() {
      wrap.classList.remove('currency-picker--open');
      btn.setAttribute('aria-expanded', 'false');
    });
    dropdown.querySelectorAll('.currency-picker__option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        currentCurrency = this.dataset.code;
        localStorage.setItem(STORAGE_KEY, currentCurrency);
        var sel = CURRENCIES.find(function(c) { return c.code === currentCurrency; });
        document.getElementById('currency-picker-label').textContent = sel.flag + ' ' + sel.code;
        dropdown.querySelectorAll('.currency-picker__option').forEach(function(o) {
          o.classList.toggle('active', o.dataset.code === currentCurrency);
          o.setAttribute('aria-selected', o.dataset.code === currentCurrency);
        });
        wrap.classList.remove('currency-picker--open');
        btn.setAttribute('aria-expanded', 'false');
        updateAllPrices();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    buildPicker();
    tagPrices();
    fetchRates();
    var cartItems = document.querySelector('.cart-drawer__items');
    if (cartItems) {
      cartObserver = new MutationObserver(debouncedRefresh);
      cartObserver.observe(cartItems, { childList: true });
      observing = true;
    }
  });

  window.WW_Currency = {
    refresh: function() { tagPrices(); updateAllPrices(); },
    formatAmount: formatAmount
  };

})();
